(function () {
  function initBlock(block) {
    if (!block || block.dataset.mrInit === '1') return;
    block.dataset.mrInit = '1';

    var scroller = block.querySelector('[data-mr-scroller]');
    var prev = block.querySelector('.swiper-btn-prev');
    var next = block.querySelector('.swiper-btn-next');
    if (!scroller) return;

    function step() {
      var card = scroller.querySelector('[data-mr-card]');
      if (!card) return 300;
      var style = window.getComputedStyle(scroller);
      var gap = parseFloat(style.columnGap || style.gap || '12') || 0;
      return card.offsetWidth + gap;
    }

    function scrollByStep(dir) {
      scroller.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
    if (next) next.addEventListener('click', function () { scrollByStep(1); });

    function updateButtons() {
      if (!prev || !next) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
      prev.toggleAttribute('disabled', scroller.scrollLeft <= 0);
      next.toggleAttribute('disabled', scroller.scrollLeft >= maxScroll);
    }
    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var target = e.target;
        if (!target || !target.closest) return;
        var card = target.closest('[data-mr-card]');
        if (!card || !block.contains(card)) return;
        scroller.scrollTo({ left: card.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.product__block--metafield_reviews').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
